import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import commonEN from './locales/en/common.json';
import homeEN from './locales/en/home.json';
import servicesEN from './locales/en/services.json';
import bookingEN from './locales/en/booking.json';
import contactEN from './locales/en/contact.json';
import aboutEN from './locales/en/about.json';

import commonES from './locales/es/common.json';
import homeES from './locales/es/home.json';
import servicesES from './locales/es/services.json';
import serviceContentES from './locales/es/serviceContent.json';
import bookingES from './locales/es/booking.json';
import contactES from './locales/es/contact.json';
import aboutES from './locales/es/about.json';

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem('language') || 'en';

const resources = {
  en: {
    common: commonEN,
    home: homeEN,
    services: servicesEN,
    booking: bookingEN,
    contact: contactEN,
    about: aboutEN,
  },
  es: {
    common: commonES,
    home: homeES,
    services: servicesES,
    serviceContent: serviceContentES,
    booking: bookingES,
    contact: contactES,
    about: aboutES,
  },
};

i18n
  .use(initReactI18next) // Pass i18n down to react-i18next
  .init({
    resources,
    lng: savedLanguage, // Default language
    fallbackLng: 'en', // Fallback language if translation missing
    
    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'home', 'services', 'serviceContent', 'booking', 'contact', 'about'],
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // Debug mode (set to false in production)
    debug: false,
    
    // React specific options
    react: {
      useSuspense: false, // Disable suspense mode
    },
  });

// Save language preference when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;

